import axios from 'axios'
import store from '@/store'
import router from '../router'
import { getToken, removeToken, getApiRequestParams, getQrcodePayApiSignParams, getLoginRequestParams } from './util'

const addErrorLog = errorInfo => {
  const { statusText, status, request: { responseURL } } = errorInfo
  let info = {
    type: 'ajax',
    code: status,
    mes: statusText,
    url: responseURL
  }
  if (!responseURL.includes('save_error_logger')) store.dispatch('addErrorLog', info)
}

class HttpRequest {
  constructor (baseUrl) {
    this.baseUrl = baseUrl
  }

  getInsideConfig () {
    const config = {
      baseURL: this.baseUrl,
      headers: {
      }
    }
    return config
  }

  destroy (url) {
    // delete this.queue[url]
    // if (!Object.keys(this.queue).length) {
    // Spin.hide()
    // }
  }

  interceptors (instance, url) {
    // 请求拦截
    instance.interceptors.request.use(config => {
      // 添加全局的loading...
      // if (!Object.keys(this.queue).length) {
      // Spin.show() // 不建议开启，因为界面不友好
      // }

      // API签名参数
      if (url === '/pcpay/createOrder') {
        config.params = getQrcodePayApiSignParams(config.params)
      } else if (url === '/Hall/UserInfo/getUserLoginData' || url === '/hall/Userinfo/getBaseUserInfo' || url === '/pcpay/checkOrderStatus') {
        config.params = getLoginRequestParams(config.params)
      } else {
        config.params = getApiRequestParams(config.params)
      }

      if (getToken()) {
        config.headers.token = getToken()
      }
      // this.queue[url] = true
      return config
    }, error => {
      return Promise.reject(error)
    })
    // 响应拦截
    instance.interceptors.response.use(res => {
      this.destroy(url)
      // if(res.data.error_code === 1403 || res.data.error_code === 1404){
      //   removeToken()
      //   router.replace({
      //     path: '/login' // 到登录页重新获取token
      //   })
      // }
      const { data, status } = res
      return { data, status }
    }, error => {
      // this.destroy(url)
      // addErrorLog(error.response)
      return Promise.reject(error)
    })
  }
  request (options) {
    const instance = axios.create()
    options = Object.assign(this.getInsideConfig(), options)
    this.interceptors(instance, options.url)
    return instance(options)
  }
}
export default HttpRequest



// WEBPACK FOOTER //
// ./src/libs/axios.js